export default __webpack_public_path__ + "static/media/icon__2.839cea03.svg";